import { render, staticRenderFns } from "./swImpact.vue?vue&type=template&id=7d838513&scoped=true&"
import script from "./swImpact.vue?vue&type=script&lang=js&"
export * from "./swImpact.vue?vue&type=script&lang=js&"
import style0 from "./swImpact.vue?vue&type=style&index=0&id=7d838513&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d838513",
  null
  
)

export default component.exports